export const REPORT_COPYRIGHT_NOTICE =
  '© 2026 Nufin GmbH. You may use, share, and adapt this content provided you always credit the source as: Moss — getmoss.com and link to the original article.'
